import { render } from "./DeleteCategory.vue?vue&type=template&id=12e4ba28"
import script from "./DeleteCategory.vue?vue&type=script&lang=js"
export * from "./DeleteCategory.vue?vue&type=script&lang=js"

import exportComponent from "D:\\courses\\Web Design\\JAVA  SCRIPT\\Vue-js courses\\resturant\\mat-aem\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__